<template>
  <SbButton
    v-if="blok.label && blok.url"
    class="content-link"
    :label="blok.label"
    variant="tertiary"
    :icon="blok.icon"
    @click="visitUrl"
  />
</template>

<script setup lang="ts">
import { isValidUrl } from '@/utils/checkers'
import { SbButton } from '@storyblok/design-system'
import type { IconName } from '@storyblok/design-system'

const props = defineProps<{
  blok: {
    label: string
    url: string
    icon: IconName
  }
  title: string
  id: string
}>()

const visitUrl = () => {
  if (props.blok.url && isValidUrl(props.blok.url)) {
    window.open(props.blok.url, '_blank')
  }
}
</script>
